import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  props: {
    segment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formats() {
      let formattingOptions = this.segment.format;

      if (typeof this.segment.format === "string") {
        formattingOptions = [this.segment.format];
      }

      return formattingOptions || [];
    },
    textData() {
      if (this.segment.text) {
        return this.segment.text;
      }

      return this.segment;
    },
    textDisplay() {
      const textLocalized = this.$dt(this.textData);

      if (!textLocalized) {
        return;
      }

      const whitespaceTokens = ".,:";
      const needsWithespaceBefore =
        whitespaceTokens.indexOf(textLocalized[0]) === -1;

      if (needsWithespaceBefore) {
        return " " + textLocalized;
      }

      return textLocalized;
    },
  },
};
